enum InsuranceTypeEnum {
  BANK = 'bank',
  INSURANCE = 'insurance',
  LESSOR = 'lessor'
}

export default InsuranceTypeEnum;
